import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=city&instance=${instance}`
    }
    
    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        pageTitle: '赋能服务-设计采购',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: '在建待建',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/在建待建'),
                path: "赋能服务-设计采购/在建待建",
            },
            {
                name: '正在招标',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/正在招标'),
                path: "赋能服务-设计采购/正在招标",
            },
            {
                name: '到底是谁',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/到底是谁'),
                path: "赋能服务-设计采购/到底是谁",
            },
            {
                name: '年报递送',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/年报递送'),
                path: "赋能服务-设计采购/年报递送",
            },
            {
                name: '培训课',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/培训课'),
                path: "赋能服务-设计采购/培训课",
            },
            {
                name: '考察团',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/考察团'),
                path: "赋能服务-设计采购/考察团",
            },
        ]
    }]
}